import { gql } from '@apollo/client'
import { useCleanFilterForRequest, useSearch, useSort } from '@btime/react-contexts'
import React from 'react'

import { triggersClient } from '../../../../utils/apollo/api'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../components/helpers/LazyAction'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const useTriggerCallsState = () => React.useContext(Context) || {}
export const useTriggerCalls = () => useTriggerCallsState()?.triggerCalls || []

const QUERY = gql`
  query TriggerCalls($page: Int, $search: String, $sort: TriggerCallSort, $filter: TriggerCallFilter) {
    triggerCalls(page: $page, search: $search, sort: $sort, filter: $filter) {
      id
      status
      triggerId
      entityType
      entityId
      data
      updatedAt
    }
  }
`

const TriggerCallsLoader = ({ children, uncontrolledChildren }) => {
  const { field, type } = useSort()
  const search = useSearch()
  const filter = useCleanFilterForRequest()

  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      search,
      sort: { field: field || 'UPDATED_AT', type: type || 'DESC' },
      filter
    },
    client: triggersClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading || state.isFetchingMore} />
      </StatePresenter>
    </Provider>
  )
}

export default TriggerCallsLoader
